import { configureStore } from '@reduxjs/toolkit'
import authSlice from '../reducers/auth.slice'
import reportError from '../reducers/error.slice'
import serviceDetail from '../reducers/serviceDetail.slice'
import serviceDetails from '../reducers/serviceDetails.slice'
import cfmServiceAddress from '../reducers/cfmServiceAddress'
import rateMaintenance from '../reducers/rateMaintenance.slice'
import closeTicket from '../reducers/closeTicket.slice'
import billingBatch from '../reducers/billingBatch.slice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    reportError,
    serviceDetail,
    cfmServiceAddress,
    rateMaintenance,
    serviceDetails,
    closeTicket,
    billingBatch
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch